import React, { Component } from "react";
import CashBackBonusTerms from "../TermsConditionModal/CashBackBonusTerms"; 
import {Link} from 'react-router-dom'
import TermsConditionModal from "../TermsConditionModal/TermsConditionModal";

class LinkContent extends Component {
  constructor(props) {
    super(props)
        this.state = {
        showModal : false
    }
     
}
 
 handleOpenModel = (val) =>{
  this.setState({
    showModal: val
  })
 }

  render() {
    const Message = `By selecting \"Add Card\", you authorize and direct Discover to provide Amazon with your name, email address, billing address and phone number, and the account number, card type, and the expiration date of your Discover Card. In addition, you consent to (a) the Discover Pay with `;
   
    return (
      <p className="termsAndCondition-footer">
        {Message}
          {/* <Link  id="cashback-bonus-terms" class="conditions" to={this.handleOpenModel} onClick={()=>this.handleOpenModel(true)}>Rewards Terms</Link>
          <TermsConditionModal close={close} title={title} footer = {footer} showModal = {this.state.showModal}>
              <CashBackBonusTerms/>
          </TermsConditionModal>   */}
          <a
          href="https://www.discover.com/credit-cards/amazon/terms-conditions.html"
          class="conditions"
          target="_blank"
          title="click here"  
        >
          Rewards Terms
        </a>
        , which registers your card in Amazon's Shop with Points program, 
          and (b) Amazon sending Discover the email address associated 
          with your Amazon account. By using the Amazon.com website and 
          Amazon mobile application, you agree to Amazon&rsquo;s{" "}
        <a
          href="https://www.amazon.com/gp/help/customer/display.html/ref=ap_signin_notification_condition_of_use?ie=UTF8&nodeId=508088"
          class="conditions"
          target="_blank"
          title="click here"
        >
          Conditions of Use
        </a>
        .
      <p class="leavingDiscoverWebsite-sub-head">Leaving Discover Website</p>
      By selecting "Add Card," you are leaving our website and entering 
      Amazon’s website or mobile application. Although we have a 
      relationship with this site/app, we do not provide the products and 
      services there. Please review the applicable privacy and security 
      policies and terms and conditions for Amazon’s site/app.
      
      </p>
    );
  
  }
}

export default LinkContent;

